"use client";
import { jsxs as w, jsx as n } from "react/jsx-runtime";
import { cva as v } from "class-variance-authority";
import { forwardRef as z, useRef as C, useImperativeHandle as R, useState as S, useCallback as d } from "react";
import { Text as W } from "../Text/Text.mjs";
import { cn as k } from "../../../utils/utils.mjs";
import { getGroupFocusWithinAccessibleStyles as Z } from "../../../utils/styles.mjs";
const G = v(
  `
    flex
    flex-col
    size-full
    rounded-sm
    border
    border-dashed
    p-3
    min-h-[7.5rem]
    min-w-[15rem]
    justify-center
    transition-colors
    
    dark:bg-neutral-dark-200
    dark:text-neutral-dark-600
    `,
  {
    variants: {
      state: {
        default: "dark:border-neutral-dark-300",
        loading: "dark:border-neutral-dark-500",
        error: "border-red-400 dark:border-red-400",
        success: "dark:border-neutral-dark-300 min-h-0"
      },
      isDragActive: {
        true: "border-gray-300 dark:border-neutral-dark-600",
        false: ""
      },
      disabled: {
        true: "cursor-not-allowed",
        false: ""
      }
    },
    defaultVariants: {
      isDragActive: !1,
      disabled: !1
    }
  }
), H = v(
  `
    text-left
    `,
  {
    variants: {
      state: {
        default: "",
        loading: "",
        success: "",
        error: "text-red-100"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), q = z(
  ({
    className: g,
    wrapperClassName: h,
    state: c = "default",
    children: x,
    useButtonWrapper: b = !0,
    helperText: f,
    onPickFile: y,
    onFileDrop: r,
    onDragEnter: a,
    onDragOver: s,
    onDragLeave: i,
    onDrop: l,
    disabled: e,
    ...A
  }, N) => {
    const o = C(null);
    R(N, () => o.current);
    const [m, u] = S(!1), T = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), !e && (u(!0), a == null || a(t));
      },
      [e, a]
    ), I = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), s == null || s(t);
      },
      [s]
    ), P = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), !t.currentTarget.contains(t.relatedTarget) && (u(!1), i == null || i(t));
      },
      [i]
    ), V = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), u(!1), !e && (t.dataTransfer.files.length > 0 && (r == null || r(t.dataTransfer.files)), l == null || l(t));
      },
      [e, r, l]
    ), j = k(
      G({ isDragActive: m, state: c, disabled: !!e }),
      Z(),
      g
    ), p = /* @__PURE__ */ n(
      "div",
      {
        "data-testid": "interactive-zone",
        "data-drag-active": m || void 0,
        onDragEnter: T,
        onDragOver: I,
        onDragLeave: P,
        onDrop: V,
        className: j,
        children: x
      }
    );
    return /* @__PURE__ */ w("div", { className: k("flex flex-col gap-2 group", h), children: [
      b ? /* @__PURE__ */ n("button", { type: "button", onClick: y, disabled: e, children: p }) : p,
      /* @__PURE__ */ n("input", { ref: o, type: "file", className: "sr-only", disabled: e, ...A }),
      f && /* @__PURE__ */ n(W, { fontWeight: "regular", fontSize: "xs", className: H({ state: c }), children: f })
    ] });
  }
);
q.displayName = "FileInput";
export {
  q as FileInput
};
